import {
  demoMarketOrders,
  demoMarketTradeContracts,
  demoOrderHistory,
  demoTradeContractById,
  demoTradeContractHistory,
} from "./demo-orders";

export const marketOrdersQuery = {
  read(_: any) {
    return demoMarketOrders;
  },
};

export const marketTradeContractQuery = {
  read(_: any) {
    return demoMarketTradeContracts;
  },
};

export const orderHistoryQuery = {
  read(_: any) {
    return demoOrderHistory;
  },
};

export const tradeContractHistoryQuery = {
  read(_: any) {
    return demoTradeContractHistory;
  },
};

export const tradeContractByIdQuery = {
  read(_: any) {
    return demoTradeContractById;
  },
};
